// External dependencies
import { Anchor, Container, Div, Row, Col } from 'atomize';
import { Link } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, FreeMode } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Trans } from 'react-i18next';

// Local dependencies
import Button from '@shared/ui/button';
import asfarma from '../../../../svg/asfarma.svg';
import innotech from '../../../../svg/innotech.svg';
import grindex from '../../../../svg/grindex.svg';
import materiaMedica from '../../../../svg/materiaMedica.svg';
import proMedCS from '../../../../svg/proMedCS.svg';
import SCG from '../../../../svg/SCG.svg';
import sopharma from '../../../../svg/sopharma.svg';
import MeducationBlock from '../meducation-block';

interface MeducationCompaniesProps {
  linkToAsana?: string;
  linkToPartners?: string;
}

export default function MeducationCompanies({
  linkToAsana,
  linkToPartners,
}: MeducationCompaniesProps) {
  const companies = [
    {
      id: 'asfarma',
      icon: asfarma,
    },
    {
      id: 'innotech',
      icon: innotech,
    },
    {
      id: 'materiaMedica',
      icon: materiaMedica,
    },
    {
      id: 'proMedCS',
      icon: proMedCS,
    },
    {
      id: 'SCG',
      icon: SCG,
    },
    {
      id: 'sopharma',
      icon: sopharma,
    },
    {
      id: 'grindex',
      icon: grindex,
    },
  ];

  return (
    <Div className="meducation-companies">
      <MeducationBlock
        blockBg="btn_default_bg"
        blockPadding={{
          t: { xs: '24px', md: '47px' },
          b: { xs: '2rem', md: '64px' },
        }}
        blockTitle="weCooperateWithCompaniesSuchAs"
        blockTitleColor="bg_black"
        blockTitleTextAlign="left"
      >
        <Div
          maxW="100%"
          m={{ t: { xs: '24px', md: '32px' } }}
          className="meducation-reviews__slider"
        >
          <Swiper
            modules={[FreeMode, Pagination]}
            pagination={{
              clickable: true,
              el: '.swiper-pagination',
            }}
            className="meducation-companies__swiper"
            loop={false}
            slidesPerView={'auto'}
            spaceBetween={30}
            breakpoints={{
              300: {
                slidesPerView: 1.5,
              },
              600: {
                slidesPerView: 2.5,
              },
              900: {
                slidesPerView: 3.5,
              },
              1200: {
                slidesPerView: 6.5,
              },
            }}
          >
            {companies.map((company) => (
              <SwiperSlide key={company.id}>
                <Div d="flex" align="center">
                  <img src={company.icon} alt="" />
                </Div>
              </SwiperSlide>
            ))}
            <Div m={{ t: { xs: '24px', md: '48px' } }}>
              <Container>
                <Row d="flex">
                  <Col
                    size={{ xs: '12', md: '6', lg: '4' }}
                    order={{ xs: 2, md: 1 }}
                  >
                    <Div m={{ t: { xs: '1.5rem', md: 0 } }}>
                      {linkToAsana && (
                        <Anchor href={linkToAsana} target="_blank">
                          <Button
                            height={'50px'}
                            typeColor="primary"
                            style={{ zIndex: 99 }}
                          >
                            <Trans>becomeAPartner</Trans>
                          </Button>
                        </Anchor>
                      )}{' '}
                      {linkToPartners && (
                        <Link to={linkToPartners}>
                          <Button
                            height={'50px'}
                            typeColor="primary"
                            style={{ zIndex: 99 }}
                          >
                            <Trans>becomeAPartner</Trans>
                          </Button>
                        </Link>
                      )}
                    </Div>
                  </Col>
                  <Col
                    size={{ xs: '12', md: '6', lg: '8' }}
                    d="flex"
                    align="center"
                    order={{ xs: 1, md: 2 }}
                  >
                    <div className="swiper-pagination"></div>
                  </Col>
                </Row>
              </Container>
            </Div>
          </Swiper>
        </Div>
      </MeducationBlock>
    </Div>
  );
}
